import type { ChainLpcLppSupplierSortMode } from '~/types/services/priceParrot';

export const chainLpcLppSupplierQueryKeys = {
  all: ['chain-lpc-lpp-supplier'] as const,
  chains: () => [...chainLpcLppSupplierQueryKeys.all, 'chain'] as const,
  chainsList: (dateFrom: string, dateTo: string) =>
    [...chainLpcLppSupplierQueryKeys.all, 'chains-list', dateFrom, dateTo] as const,
  breakdown: (
    chainName: string,
    dateFrom: string,
    dateTo: string,
    sort: ChainLpcLppSupplierSortMode,
    offerBk: string | null,
  ) =>
    [
      ...chainLpcLppSupplierQueryKeys.chains(),
      chainName,
      'breakdown',
      dateFrom,
      dateTo,
      sort,
      offerBk ?? 'all',
    ] as const,
  dailyTrend: (chainName: string, offerBk: string, dateFrom: string, dateTo: string) =>
    [...chainLpcLppSupplierQueryKeys.chains(), chainName, 'daily-trend', offerBk, dateFrom, dateTo] as const,
  rollupTrend: (chainName: string, dateFrom: string, dateTo: string) =>
    [...chainLpcLppSupplierQueryKeys.chains(), chainName, 'rollup-trend', dateFrom, dateTo] as const,
};
